<template>
  <div class="wrap">
    <img src="//editor.xesimg.com/tailor/resource/404-1654524121355.png" />
  </div>
</template>
<style scoped>
body {
  background: #fff;
}
.wrap {
  width: 1200px !important;
  margin: 16px auto 0;
  padding: 0;
}
.wrap img {
  width: 100%;
}
</style>

<script>
export default {
  name: 'not-found'
  // beforeMount () {
  //   window.location.replace('//online.xueersi.com/404')
  // }
}
</script>



// WEBPACK FOOTER //
// ./src/views/NotFound.vue